import BaseTable, {AutoResizer, SortOrder} from 'react-base-table'
import React, {useEffect, useState} from 'react';
import 'react-base-table/styles.css'
import './base-table.css'
import styled from 'styled-components';

const ReferenceTable = ({refData}) => {
    const [data, setData] = useState({});
    const [sortBy, setSortBy] = useState({
        key: 'cage_status', 
        order: SortOrder.ASC
    })

    useEffect(() => {
    
        setData(refData.map((doc, index) => {
            return {
                partNumber: doc.part_number,
                cageCode: doc.cage_code,
                cageStatus: doc.cage_status,
                vendorName: doc.vendor_name
                
            }
        }));
    }, [refData])

    const columns = [
        {
            key: 'partNumber',
            dataKey: 'partNumber',
            title: 'Part Number',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },

        {
        key: 'cageCode',
        dataKey: 'cageCode',
        title: 'Cage Code',
        width: 150,
        align: 'center',
        resizable: true,
        sortable: false
        },

        {
        key: 'cageStatus',
        dataKey: 'cageStatus',
        title: 'Cage Status',
        width: 150,
        align: 'center',
        resizable: true,
        sortable: false
        },

        {
        key: 'vendorName',
        dataKey: 'vendorName',
        title: 'Entity Name',
        width: 300,
        align: 'center',
        resizable: true,
        sortable: false
        }
        
    ]

    const Container = styled.div`
        width: calc(50vw + 220px);
        height: 50vh;
        `


return (
    <>
        <Container>
            <AutoResizer>
                {({ width, height }) => (
                    <BaseTable
                        className='base-table'
                        width={width}
                        height={height}
                        columns={columns}
                        data={data}
                        sortBy={sortBy}
                        
                    />
                )}
            </AutoResizer>
        </Container>
    </>
    );
}

export default ReferenceTable